import React, { useEffect, useState } from "react";
import "../css files/langslider.css";

import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import Carousel from "react-elastic-carousel";
const img_lang = require("../../assets/html.png");
const img_lang1 = require("../../assets/css.png");
const img_lang2 = require("../../assets/js.png");
const img_lang3 = require("../../assets/react js.png");
const img_lang4 = require("../../assets/react native.png");
const img_lang5 = require("../../assets/php.png");
const img_lang6 = require("../../assets/vue js.png");
const img_lang7 = require("../../assets/bootstrap.png");
const img_lang8 = require("../../assets/nodejs.png");
const img_lang9 = require("../../assets/mongodb.png");
const img_lang10 = require("../../assets/postgre.png");
const img_lang11 = require("../../assets/mysql.png");
const img_lang12 = require("../../assets/jquery.png");
const img_lang13 = require("../../assets/laravel.png");
const img_lang14 = require("../../assets/angular.png");

const allLangBoxContent = [
  {
    langName: "React JS",
    langImg: img_lang3,
    langContet: `React, sometimes referred to as a frontend JavaScript framework, is a JavaScript library created by Facebook.React is a tool for building UI components.`,
    langLink: `https://reactjs.org/docs/hello-world.html`,
  },
  {
    langName: "React Native",
    langImg: img_lang4,
    langContet: `React Native combines the best parts of native development with React, a best-in-class JavaScript library for building user interfaces.You can use React Native today in your existing Android and iOS projects or you can create a whole new app from scratch.`,
    langLink: `https://reactnative.dev/docs/getting-started`,
  },
  {
    langName: "PHP",
    langImg: img_lang5,
    langContet: `PHP is a general-purpose scripting language geared toward web development. It is a server scripting language, and a powerful tool for making dynamic and interactive Web pages.`,
    langLink: `https://www.w3schools.com/php/php_intro.asp`,
  },
  {
    langName: "Laravel",
    langImg: img_lang13,
    langContet: `Laravel is a web application framework with expressive, elegant syntax. We’ve already laid the foundation — freeing you to create without sweating the small things.`,
    langLink: `https://laravel.com/docs/9.x`,
  },
  {
    langName: "Node JS",
    langImg: img_lang8,
    langContet: `Node.js is an open source server environment.It runs on various platforms (Windows, Linux, Unix, Mac OS X, etc.). It uses JavaScript on the server`,
    langLink: `https://nodejs.org/en/`,
  },
  {
    langName: "HTML",
    langImg: img_lang,
    langContet: `HTML stands for Hyper Text Markup Language ,it is the standard markup language for creating Web pages`,
    langLink: `https://www.w3schools.com/html/html_intro.asp`,
  },
  {
    langName: "CSS",
    langImg: img_lang1,
    langContet: `Cascading Style Sheets (CSS) is a stylesheet language used to
    describe the presentation of a document written in HTML or XML .`,
    langLink: `https://www.w3schools.com/css/css_intro.asp`,
  },
  {
    langName: "Javascript",
    langImg: img_lang2,
    langContet: `JavaScript (JS) is a lightweight, interpreted, or compiled programming language. While it is most well-known as the scripting language for Web pages.`,
    langLink: `https://www.w3schools.com/js/js_intro.asp`,
  },

  {
    langName: "Vue JS",
    langImg: img_lang6,
    langContet: `Vue is a JavaScript framework for building user interfaces. It builds on top of standard HTML, CSS and JavaScript, and provides a declarative and component-based programming model that helps you efficiently develop user interfaces, be it simple or complex.`,
    langLink: `https://vuejs.org/guide/introduction.html`,
  },
  {
    langName: "Bootstrap",
    langImg: img_lang7,
    langContet: `Bootstrap is a free front-end framework for faster and easier web development.It includes HTML and CSS based design templates for typography, forms, buttons, tables, navigation, modals, image carousels and many other, as well as optional JavaScript plugins`,
    langLink: `https://www.w3schools.com/bootstrap5/bootstrap_get_started.php`,
  },

  {
    langName: "Mongodb",
    langImg: img_lang9,
    langContet: `One of the most popular NoSQL database is MongoDB.MongoDB is a source-available cross-platform document-oriented database program. Classified as a NoSQL database program, MongoDB uses JSON-like documents with optional schemas.`,
    langLink: `https://www.w3schools.com/nodejs/nodejs_mongodb.asp`,
  },
  {
    langName: "Postgresql",
    langImg: img_lang10,
    langContet: `PostgreSQL is a powerful, open source object-relational database system with over 30 years of active development that has earned it a strong reputation for reliability, feature robustness, and performance.`,
    langLink: `https://www.postgresql.org/docs/current/`,
  },
  {
    langName: "Mysql",
    langImg: img_lang11,
    langContet: `One of the most popular databases is MySQL.It is used database applications`,
    langLink: `https://www.w3schools.com/nodejs/nodejs_mysql.asp`,
  },
  {
    langName: "Jquery",
    langImg: img_lang12,
    langContet: `jQuery is a fast, small, and feature-rich JavaScript library. It makes things like HTML document traversal and manipulation, event handling, animation, and Ajax much simpler with an easy-to-use API that works across a multitude of browsers. With a combination of versatility and extensibility, jQuery has changed the way that millions of people write JavaScript.`,
    langLink: `https://www.w3schools.com/jquery/jquery_get_started.asp`,
  },
  {
    langName: "Angular JS",
    langImg: img_lang14,
    langContet: `AngularJS was a JavaScript-based open-source front-end web framework for developing single-page applications. It was maintained mainly by Google and a community of individuals and corporations.`,
    langLink: `https://www.w3schools.com/angular/`,
  },
];

function LanguageSliderSection(props) {
  const customSlider = React.useRef();
  const [hoverCardContent, setHoverCardContent] = useState(false);
  const breakPoints = [
    { width: 1, itemsToShow: 1, pagination: false },
    { width: 550, itemsToShow: 2, itemsToScroll: 2, pagination: false },
    { width: 850, itemsToShow: 3, pagination: false },
    { width: 1000, itemsToShow: 4, pagination: false },
  ];

  const renderLangBox = allLangBoxContent.map((perLangBox) => {
    return (
      //   <div className="language_box_container" key={Math.random()}>
      <div className="flip-card" key={Math.random()}>
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <div className="language_img_container">
              <img src={perLangBox.langImg} alt="lang_img" />
            </div>
            <p className="language_text">{perLangBox.langName}</p>
          </div>
          <div className="flip-card-back">
            <p className="extra_text_paragraph">{perLangBox.langContet}</p>
            {/* <a href={perLangBox.langLink} className="read_more_text">
              Read more...
            </a> */}
          </div>
        </div>
      </div>
      //   </div>
    );
  });

  return (
    <section className="main_language_slider_container">
      <div className="work_flow_under_main_container">
        <div className="workflow_text_container">
          <p className="work_flow_text_heading">
            Our team is <span className="highlighted_title_text">working </span>
            on <span className="highlighted_title_text">languages</span> such as
          </p>
        </div>

        <div className="lang_body_container">
          <Carousel
            breakPoints={breakPoints}
            ref={customSlider}
            enableAutoPlay={false}
            showArrows={false}
            autoPlaySpeed={1500}
          >
            {renderLangBox}
          </Carousel>
        </div>
        <div className="lang_btn_container">
          <button
            className="left_icon_lang_btn same_btn_styling"
            onClick={() => customSlider.current.slidePrev()}
          >
            <MdKeyboardArrowLeft />
          </button>
          <button
            className="right_icon_lang_btn same_btn_styling"
            onClick={() => customSlider.current.slideNext()}
          >
            <MdKeyboardArrowRight />
          </button>
        </div>
      </div>
    </section>
  );
}

export default LanguageSliderSection;
